import React from 'react';
import {TextField, withStyles} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {withTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import departments from "../../datas/departements-region.json";
import MenuItem from "@material-ui/core/MenuItem";
import countries from "i18n-iso-countries";


const styles = {
    appRegionAutocomplete:{
        width: "100%",
        lineHeight: "1.5rem",
        border: '1px solid #E0E0E0',
        borderRadius: 6,
        background: '#fff',
        overflow: 'hidden',
        '&.errorWrapperCountry':{
            border: '1px solid #ff0000 !important'
        },
        "& input":{
            padding: "18.5px 14px !important",
            fontSize: "1rem",
            fontFamily: `"Nunito", sans-serif`,
            "&::placeholder":{
                opacity:0.8,
                fontWeight: 100,
            }
        },
        '& .MuiInput-underline:before': {
            content: 'none!important'
        },
        '& .MuiInput-underline:after': {
            content: 'none!important'
        },
        '& .MuiInputBase-root': {
            paddingRight: 0
        },
        '& .MuiTypography-body1': {
            lineHeight: 1
        }
    },
    option: {
        width: "100%"
    }
};

class AppRegionAutocomplete extends React.Component{
    constructor(props) {
        super(props);
    }

    loadDepartments = () => {
        const departmentOptions = departments.map(departmentData=>{
            return {code: departmentData.num_dep.toString().toUpperCase(),label: departmentData.dep_name + ` (${departmentData.num_dep})`};
        });
        departmentOptions.sort((a,b)=>{
           return a.label.localeCompare(b.label);
        });
        return departmentOptions;
    }

    render() {
        const {classes,i18n,validate,tReady,value,defaultValue,...otherProps} = this.props;
        let self = this;
        let valueOption = value;
        let defaultValueOption = defaultValue;
        if (typeof valueOption === "string"){
            const valueItem = departments.find((item)=>item.num_dep.toString() === valueOption);
            if (valueItem !== null){
                valueOption = {
                    code: defaultValueOption,
                    label: valueItem.dep_name
                }
            }
        }
        if (typeof defaultValueOption === "string"){
            const defaultItem = departments.find((item)=>item.num_dep.toString() === defaultValueOption);
            if (defaultItem !== null){
                defaultValueOption = {
                    code: defaultValueOption,
                    label: defaultItem.dep_name
                }
            }
        }
        return (
            <Autocomplete
                className={`${classes.appRegionAutocomplete}`}
                options={this.loadDepartments()}
                classes={{
                    option: classes.option
                }}
                autoHighlight
                value={valueOption}
                defaultValue={defaultValueOption}
                getOptionLabel={option => option.label}
                noOptionsText={this.props.t("label.no_result")}
                isOptionEqualToValue={(option,value)=>{
                    return option.code === value || option === value || (!!value && !!value.code && option.code === value.code);
                }}
                renderInput={params => {
                    return <TextField
                        {...params}
                        fullWidth
                        className={classes.inputText}
                        placeholder={self.props.hasOwnProperty("inputPlaceHolder")?self.props.inputPlaceHolder:self.props.t('label.region')}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password'
                        }}
                    />;
                }}
                {...otherProps}
            />);
    }
}

AppRegionAutocomplete.propsType = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(AppRegionAutocomplete));
